module.exports = __webpack_public_path__ + "static/media/Damian Willcox.8488e4b8.png";